import { FAQ_ROUTE } from "src/constants/routes";
import { React, useState, useEffect, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import footer from "assets/images/logo.png";
import { BsMoon, BsSun } from "react-icons/bs";

const Footer = () => {
  return (
    <footer className="mt-3">
      <div className="container px-sm-5">
        <div className="d-flex justify-content-between footer-desc">
          <div className="col-md-6">
            <div className="d-flex mb-1">
              {/* <img src={footer} alt="footer-img" /> */}
              <h2 className="title mx-1">GangstaBet</h2>
            </div>
            <p className="footer-paragraph">
              GangstaBet is a collection of 5,555 unique Gangsters & Detectives
              on the ICON blockchain.
            </p>
          </div>
        </div>
        <hr className="horizontal-line" />
        <div className="d-flex justify-content-between footer-nav">
          <p>Copyright © GangstaBet {new Date().getFullYear()}</p>
          <div className="links">
            {/* <Link className="link" to="">
              Policy
            </Link> */}
            {/* <Link className="link" to={FAQ_ROUTE.INDEX}>
              FAQ
            </Link> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
